import { PageCardActions } from './Actions';
import { PageCardApiResponse } from './ApiResponse';
import { PageCard } from './Card';
import { PageCardEvents } from './Events';
import { PageCardInformation } from './Information';
import { PageCardsOverview } from './Overview';
import { PageCardTokens } from './Tokens';

export { PageCardsOverview } from './Overview';

export const CARDS = {
  Cards: PageCardsOverview,
  CardSection: PageCard,
  CardEdit: PageCardInformation,
  CardEvents: PageCardEvents,
  CardActions: PageCardActions,
  CardApiResponse: PageCardApiResponse,
  CardTokens: PageCardTokens,
} as const;
